import { getIsChatEnabled } from '../../modules/GlintsChat/selectors';

export default function useIsChatEnabled() {
  return getIsChatEnabled();
}
